import { Switch } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import Select, { GroupBase, StylesConfig } from "react-select";
import IwSwitch from "../app/IwSwitch";

const styleProvider: StylesConfig<any, false, GroupBase<any>> = {
  control: (base) => ({
    ...base,
    borderRadius: "4px",
    borderColor: "#ccc",
    boxShadow: "none"
  })
};

interface FilterInsightsProps {
  filters: {
    allTags: boolean;
    unTaggedInsights: boolean;
    change: boolean;
  };
  setFilters: Dispatch<SetStateAction<FilterInsightsProps["filters"]>>;
}

const FilterInsights = ({ filters, setFilters }: FilterInsightsProps) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleToggle = (key) => {
    setFilters((prev) => ({ ...prev, change: true, [key]: !prev[key] }));
    setMenuOpen(true);
  };

  const getOptions = () => [
    {
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          onClick={() => handleToggle("allTags")}
        >
          <span>All Tags</span>

          <IwSwitch checked={filters.allTags} />
        </div>
      ),
      value: "allTags"
    },
    {
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          onClick={() => handleToggle("unTaggedInsights")}
        >
          <span>Untagged Insights</span>
          <IwSwitch checked={filters.unTaggedInsights} />
        </div>
      ),
      value: "unTaggedInsights"
    }
  ];

  return (
    <Select
      menuIsOpen={isMenuOpen}
      options={getOptions()}
      styles={styleProvider}
      openMenuOnFocus={true}
      isSearchable={false}
      value={null}
      placeholder="Filter Insights by Tag"
      onMenuOpen={() => setMenuOpen(true)}
      onMenuClose={() => setMenuOpen(false)}
      onChange={() => {
        setMenuOpen(true);
      }}
    />
  );
};

export default FilterInsights;
